module.exports = __webpack_public_path__ + "img/amrelfouly.b743e10d.jpg";